import { useCallback, useState } from "react";
import { JsonView, defaultStyles } from "react-json-view-lite";
import "react-json-view-lite/dist/index.css";

import "./styles.css";

import { cn } from "@/lib/utils";

interface PrettyJsonViewProps {
  data: Record<string, unknown> | unknown[];
  rawText: string;
  className?: string;
}

const shouldExpandNode = (level: number) => level < 2;

const PrettyJsonView = ({ data, rawText, className }: PrettyJsonViewProps) => {
  const [isRawVisible, setIsRawVisible] = useState(false);
  const handleShouldExpandNode = useCallback((level: number) => shouldExpandNode(level), []);

  return (
    <div
      className={cn(
        "pretty-json-view overflow-x-auto rounded-md border border-gray-200 bg-gray-50/70 px-3 py-2 text-sm text-gray-800",
        className,
      )}
    >
      <div className="mb-2 flex justify-end">
        <button
          type="button"
          className="text-xs font-medium text-gray-500 underline-offset-2 hover:text-gray-700 hover:underline"
          onClick={() => setIsRawVisible(value => !value)}
        >
          {isRawVisible ? "View pretty" : "View raw"}
        </button>
      </div>
      {isRawVisible ? (
        <pre className="m-0 overflow-x-auto whitespace-pre rounded bg-transparent p-0 font-mono text-xs leading-5 text-gray-800">
          {rawText}
        </pre>
      ) : (
        <JsonView
          data={data}
          shouldExpandNode={handleShouldExpandNode}
          style={defaultStyles}
          clickToExpandNode
        />
      )}
    </div>
  );
};

export default PrettyJsonView;
